<script setup>
import { ref, onMounted, computed, reactive } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useDishesStore } from "@/stores/storeDishes";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useModals } from "@/utils/useModals";
import ProfileDish from "@/components/profile/ProfileDish.vue";
import BasePictureCropper from "@/components/ui/BasePictureCropper.vue";

const storeRequests = useRequestsStore();
const storeDishes = useDishesStore();
const storeField = useFieldsStore();
const { openModal } = useModals();

const emit = defineEmits(["toggleTab"])

const userDishesApplication = reactive({
	photo: storeField.fields.photoMenu,
	isPicAdd: false,
})

onMounted(async () => {

	
});
</script>
<template>
	<div class="questionnare">
		<p class="questionnare__desc">
			Добавьте фото тех же блюд, которые вы указали в заявке, но уже в интерьере ресторана, 
			а также добавьте фотографию меню в заведении, чтобы показать, что блюда действительно подаются
		</p>
		<div class="questionnare__dishes-list ">
			<div class="dishes-list">
				<ProfileDish 
					v-for="(dish, index) in storeRequests.userData.survey?.dishes" 
					:index="index" 
					:key="dish.id" 
					:dish="dish"
					:isControls="false" 
					:is-interiorMode="true"
					:readonly="true"
					@delete="storeDishes.deleteDish(dish.id)" 
				/>
			</div>
			<div :class="['dish not-controls --menu']">
				<div class="dish__box">
					<div class="dish__pic">
						<BasePictureCropper  :no-crop="true" v-model:photo="storeField.fields.photoMenu" :userApplication="userDishesApplication"/>
					</div>
					<div class="dish__controls">
						<h4 class="dish__name">Меню</h4>
					</div>
					<p class="dish__textarea">Сфотографируйте своё меню так, чтобы на фото были видны все блюда, которые участвуют в конкурсе</p>
				</div>
			</div>
		</div>
		<p style="color: var(--red);text-align: center;font-size: 16px;margin-bottom: 20px;" class="text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
		<button 
			:disabled="storeField.isApplicationExtraBtn" 
			class="questionnare__btn form__btn btn --middle mobile-full" 
			type="button"
			@click="storeRequests.extraSurvey(), emit('toggleTab', 1)"
		>
			
			<span v-if="!storeRequests.loaderBtn">Подтвердить блюда</span>
			<img v-else class="form-loader" width="36" height="36" src="@/assets/img/icons/loader_white.svg" alt="изображение" />
		</button>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.questionnare {
	width: 100%;
}
.questionnare__apllication {
	margin-bottom: 5.4rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 4rem;
	}
}
.questionnare__desc {
    max-width: 79%;
	font-weight: 400;
	font-size: 1.8rem;
	line-height: 140%;
	margin-bottom: 3.4rem;
	@media (max-width: vars.$m) {
		max-width: 100%;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
		line-height: 133%;
		margin-bottom: 2.5rem;
	}
}
.questionnare__dishes-list {
	gap: 20px;
	margin-bottom: 40px;
}
.questionnare__btn-text {
	display: block;
	width: fit-content;
	margin: 3.4rem auto 0;
}
.questionnare__btn {
	margin: 0 auto;
}

.dish {
	&.--menu {
		
		padding-top: 3.4rem;
		margin-top: 3.4rem;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		padding-bottom: 3.4rem;
	}
    &:not(:first-child) {
    }
    &:not(:last-child) {
    }

	&.not-controls {
	}
}
.dish__box {
	width: 100%;
	display: grid;
	grid-template-columns: 33.8rem 1fr;
    grid-template-rows: 20px 1fr;
	gap: 2.6rem 2rem;
	align-items: stretch;
	@media (max-width: vars.$m) {
		grid-template-columns: 1fr;
		gap: 20px;
		grid-template-rows: 20px 1fr auto;
		align-items: start;
		justify-items: center;
	}
	
}
.dish__pic {
	width: 100%;
	grid-column: 1/2;
	grid-row: 1/3;
	@media (max-width: vars.$m) {		
		width: 33.8rem;
		grid-column: 1/2;
		grid-row: 2/3;
	}
	@media (max-width: vars.$x425) {
		width: 100%;
	}
}
.dish__controls {
	display: flex;
	align-items: center;
    gap: 1.6rem;
	grid-column: 2/3;
	grid-row: 1/2;
	@media (max-width: vars.$m) {
		grid-column: 1/2;
		grid-row: 1/2;		
		width: 100%;
	}
}
.dish__name {
	font-family: var(--font-family-md);
	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
	color: var(--red);
}
.dish__delete-btn {
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 120%;
    color: rgba(29, 29, 27, 0.5);
    border-bottom: 1px solid currentColor;
    @media (hover: hover){
        &:hover {
            border-color: transparent;
        }
    }
}
.dish__textarea {
	grid-column: 2/3;
	grid-row: 2/3;
	@media (max-width: vars.$m) {
		grid-column: 1/2;
		grid-row: 3/4;
		width: 100%;
	}
}

</style>
